var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-payment-method-card",
    {
      attrs: { center: "", clickable: "" },
      on: {
        click: function ($event) {
          return _vm.createFirstPayment()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("w-fa", { staticClass: "mr icon", attrs: { icon: "plus" } }),
          _vm._v(_vm._s(_vm.$ct("payment-methods.new")) + " "),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }